import React from 'react';
import PropTypes from 'prop-types';
import './styles/sign.scss';
import BlinkingLights from './BlinkingLights'
import SignDisplayOverlay from './SignDisplayOverlay'
import * as deviceStates from './constants/deviceStates';
import * as programStates from './constants/programStates';
import Tooltip from '@material-ui/core/Tooltip';
import Moment from 'react-moment';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import DisplayContent from './DisplayContent';

const SignView = ({
  id, name, source, data, error, loading, onClick
}) => {

  let errorState = deviceStates.UNKNOWN;
  let signState = {program: "", program_state: -4 };
  
  let programState = programStates.UNKNOWN_TRANSLATION_GER;
  let signCommand = {program: "", program_state: -4 };
  let clusterState = {};
  let hasBlinkingLights = false;
  let blinkingLightsState = {program: "", program_state: -4 };
  let ambientBrightness;
  let programStateSymbol = "";

  if(error !== undefined) {
    console.log(error);
  }

  if(source && source.blinking_lights !== null) {
    hasBlinkingLights = source.blinking_lights !== null;
  }
  
  if(data !== undefined) {
    if(data.device.sign_state !== null) {
      signState = data.device.sign_state;
      if(signState.program_state === programStates.AUTOMATIC_PROGRAM) {
        programState = "Automatikprogramm";
        programStateSymbol = "A";
      } else if(signState.program_state === programStates.SPECIAL_PROGRAM) {
          programState = "Sonderprogramm";
          programStateSymbol = "S";
      } else if(signState.program_state === programStates.MANUAL_PROGRAM) {
          programState = "Handprogramm";
          programStateSymbol = "H";
      } else if(signState.program_state === programStates.LOCAL_PROGRAM) {
          programState = "Vorortbetrieb";
          programStateSymbol = "V";
      }
    }
    
    if(data.device.sign_command !== null && data.device.sign_command !== undefined) {
      signCommand = data.device.sign_command;
    }
    if(data.device.cluster !== null && data.device.cluster !== undefined) {
      if(data.device.cluster.cluster_state !== null && data.device.cluster.cluster_state !== undefined) {
        clusterState = data.device.cluster.cluster_state;
      }
    }
    if(hasBlinkingLights && data.device.blinking_lights.blinking_lights_state != null) {
      blinkingLightsState = data.device.blinking_lights.blinking_lights_state;
    }
    if(data.device.ambient_brightness !== null && data.device.ambient_brightness !== undefined) {
      ambientBrightness = data.device.ambient_brightness.brightness;
    }
    errorState = signState.error_state;
    if(errorState > 3) {
      errorState = deviceStates.UNKNOWN;
    }
  }

  const malfunction = errorState === deviceStates.MALFUNCTION || errorState === deviceStates.COMMUNICATION_FAILURE || errorState === deviceStates.NOT_CONNECTED_NO_DATA;

  return (
      <div className="sign-device" onClick={onClick}>
        <div className="sign-device-container">
          {hasBlinkingLights ? <BlinkingLights blinking={blinkingLightsState.program === "TLS.GelbesBlinklicht"}/> : <React.Fragment/>}
          <div className="operating-mode">
            <div className="operating-mode-container">
              {clusterState.operating_mode !== 3 ? <div className="operating-mode-symbol">{programStateSymbol}</div> : <React.Fragment/>}
              {clusterState.operating_mode === 1 ? <VisibilityOffIcon className="operating-mode-icon"/> : <React.Fragment/>}  
              {clusterState.operating_mode === 3 ? <div className="operating-mode-symbol">X</div> : <React.Fragment/>}                    
            </div>
          </div>
          {/* {source.sign_type === "HYBRID_64_X_64"? 'hybrid':''} */}
          <div className={(malfunction?`display error ${source.sign_type === "HYBRID_64_X_64"? 'hybrid':''}`:`display ${source.sign_type === "HYBRID_64_X_64"? 'hybrid':''}`)}>
            <Tooltip placement="top" title={
              <React.Fragment>
                <p>{"Ist: "}</p>
                <p>&nbsp;&nbsp;<Moment format="DD.MM.YYYY HH:mm:ss">{signState.timestamp}</Moment></p>
                <p>&nbsp;&nbsp;{signState.program + " (" + programState + ")"}</p>
                <p>{"Soll: "}</p>
                <p>&nbsp;&nbsp;<Moment format="DD.MM.YYYY HH:mm:ss">{signCommand.timestamp}</Moment></p>
                <p>&nbsp;&nbsp;{signCommand.program + " (" + programState + ")"}</p>
              </React.Fragment>}>
              <div className="device-inner">

                <DisplayContent contentID = {signState.program} ID={source.id} signType={source.sign_type}/>

                <SignDisplayOverlay signType={source.sign_type} loading={loading} errorState={errorState}/>
              </div>
            </Tooltip>
          </div>
          
        </div>
        <div className="brightnessInfo">
              {ambientBrightness !== undefined && ambientBrightness >= 0 ? <div className="brightnessInfoItem">{ambientBrightness} Lx</div>:<div className="brightnessInfoItem"></div>}
              {clusterState.brightness !== undefined && clusterState.brightness >= 0 ? <div className="brightnessInfoItem">{clusterState.brightness} %</div>:<div className="brightnessInfoItem"></div>}
        </div>
        <div className="label">{name}</div>
      </div>
  );
};

SignView.propTypes = {
  name: PropTypes.string,
  source: PropTypes.object,
  data: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

export default SignView;